
import React from 'react';
import { AlertCircle, Users, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const AffiliateAccessDenied = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20 p-6 flex items-center justify-center">
      <Card className="max-w-2xl w-full border-border/50 bg-gradient-to-br from-card via-card/95 to-muted/20 backdrop-blur-xl">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <div className="p-3 rounded-2xl bg-gradient-to-br from-amber-500/20 via-amber-500/10 to-transparent border border-amber-500/20">
              <AlertCircle className="h-8 w-8 text-amber-500" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold bg-gradient-to-r from-foreground via-foreground to-amber-600 bg-clip-text text-transparent">
            Market Analysis AI - Tính năng Premium
          </CardTitle>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="text-center text-muted-foreground">
            <p className="text-lg mb-4">
              Tính năng Market Analysis AI chỉ dành cho khách hàng được giới thiệu bởi đối tác Affiliate của chúng tôi.
            </p>
          </div>
          
          <div className="grid gap-4 md:grid-cols-2">
            <div className="p-4 rounded-lg bg-gradient-to-br from-emerald-500/10 to-transparent border border-emerald-500/20">
              <div className="flex items-center gap-3 mb-2">
                <Users className="h-5 w-5 text-emerald-500" />
                <h3 className="font-semibold text-foreground">Tìm Đối tác Affiliate</h3>
              </div>
              <p className="text-sm text-muted-foreground">
                Liên hệ với đối tác Affiliate của Trade Bot 365 để được hỗ trợ và truy cập tính năng premium này.
              </p>
            </div>
            
            <div className="p-4 rounded-lg bg-gradient-to-br from-blue-500/10 to-transparent border border-blue-500/20">
              <div className="flex items-center gap-3 mb-2">
                <Star className="h-5 w-5 text-blue-500" />
                <h3 className="font-semibold text-foreground">Trở thành Affiliate</h3>
              </div>
              <p className="text-sm text-muted-foreground">
                Đăng ký trở thành đối tác Affiliate để sử dụng tính năng này và kiếm hoa hồng.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
            <Button 
              onClick={() => window.open('https://t.me/tradebot365support', '_blank')}
              className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700"
            >
              <Users className="h-4 w-4 mr-2" />
              Liên hệ Support
            </Button>
            
            <Button 
              variant="outline" 
              onClick={() => window.location.href = '/affiliate/onboarding'}
              className="border-blue-500/30 text-blue-600 hover:bg-blue-500/10"
            >
              <Star className="h-4 w-4 mr-2" />
              Trở thành Affiliate
            </Button>
          </div>
          
          <div className="text-center text-sm text-muted-foreground">
            <p>
              Bạn đã có mã giới thiệu? Vui lòng đăng xuất và đăng ký lại với link giới thiệu.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
